import { FormsLang } from './forms/forms.lang';
export const WSPanelLang = {
    wss: 'لیست فضاهای کاری',
    entrance: 'ورود',
    form: 'فرم',
    answersheetCount: 'تعداد پاسخنامه',
    lastModified: 'آخرین زمان فعالیت',
    questionerPublishes: 'فرم های پرسشگر',
    emptyStateWS: 'فضای کاری متعلق به شما یا اشتراک گذاشته شده با شما وجود ندارد',
    emptyStateForm: 'شما فرم مورد علاقه‌ای ندارید.',
    emptyStateFormInWs: 'فرم فعالی برای شما در این فضای کاری وجود ندارد',
    favForms: 'فرم‌های مورد علاقه',
    forms: FormsLang,
};
